// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
/* tslint:disable */
export enum CompositeFilter_Operator {
  OPERATOR_UNSPECIFIED = 0,
  AND = 1,
  OR = 2,
}

export enum FieldFilter_Operator {
  OPERATOR_UNSPECIFIED = 0,
  LESS_THAN = 1,
  LESS_THAN_OR_EQUAL = 2,
  GREATER_THAN = 3,
  GREATER_THAN_OR_EQUAL = 4,
  EQUAL = 5,
  OVERLAP = 6,
}

export enum FieldFilter_OperatorFunction {
  NONE = 0,
  ANY = 1,
  ALL = 2,
}

export enum UnaryFilter_Operator {
  OPERATOR_UNSPECIFIED = 0,
  IS_NAN = 2,
  IS_NULL = 3,
}

export enum Operator {
  AVG = 0,
  COUNT = 1,
  SUM = 2,
  MIN = 3,
  MAX = 4,
  COUNT_DISTINCT = 5,
}

export enum Calendar {
  UNSPECIFIED = 0,
  CALENDAR_MINUTE = 1,
  CALENDAR_HOUR = 2,
  CALENDAR_DAY = 3,
  CALENDAR_WEEK = 4,
  CALENDAR_MONTH = 5,
  CALENDAR_QUARTER = 6,
  CALENDAR_YEAR = 7,
}

export enum GroupBy_Operator {
  OPERATOR_GROUP_BY = 0,
  OPERATOR_ROLLUP = 1,
  OPERATOR_CUBE = 2,
}

export enum Metric {
  CONNECTED_GMB_ACCOUNTS = 0,
  QUERIES_DIRECT = 1,
  QUERIES_INDIRECT = 2,
  VIEWS_MAPS = 3,
  VIEWS_SEARCH = 4,
  ACTIONS_WEBSITE = 5,
  ACTIONS_PHONE = 6,
  ACTIONS_DRIVING_DIRECTIONS = 7,
  TOTAL_LISTINGS = 8,
  TOTAL_INACCURATE_LISTINGS = 9,
  TOTAL_CITATIONS = 10,
  TOTAL_REVIEWS = 11,
  NEW_REVIEWS = 12,
  NEW_POSITIVE_REVIEWS = 13,
  NEW_POSITIVE_UNRESPONDED_REVIEWS = 14,
  NEW_NEGATIVE_REVIEWS = 15,
  NEW_NEGATIVE_UNRESPONDED_REVIEWS = 16,
  NEW_POSITIVE_RESPONDED_REVIEWS = 17,
  AVERAGE_REVIEW_RATING = 18,
  LMI_GRADE_LISTINGS = 19,
  LMI_GRADE_REPUTATION = 20,
  LMI_GRADE_SOCIAL = 21,
  LMI_GRADE_SEO = 22,
  LISTING_SYNC_SITES_CURRENTLY_SYNCING = 23,
  LISTING_SYNC_SITES_TOTAL = 24,
}

export enum Alignment {
  ALIGN_NONE = 0,
  ALIGN_DELTA = 1,
  ALIGN_INTERPOLATE = 3,
  ALIGN_NEXT_OLDER = 4,
  ALIGN_EXACT = 5,
  ALIGN_CUSTOM = 6,
}

export enum Order {
  ORDER_ASC = 0,
  ORDER_DESC = 1,
}

export enum CustomAlignerFields {
  BUCKET_START = 'aligner__start_time',
  BUCKET_END = 'aligner__end_time',
}
